import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { environment } from '@environments/environment';
import { AngularPaths, Consumer, LoginByTokenRequest } from '@models/index.model';
import { LoadingService, SessionService } from '@services/index.service';
import { finalize, map, Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class LoginByTokenGuard  {
  public isMobile: boolean;
  public currentConsumer: Consumer;

  public constructor(
    private _session: SessionService,
    private _router: Router,
    private _loading: LoadingService
  ) {
    this.isMobile = environment.platform === 'mobile';
    if (this.isMobile) {
      this.currentConsumer = Consumer.SIGNTRUST_APP;
    } else {
      this.currentConsumer = Consumer.PERSONAL_AREA;
    }
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log('LoginByTokenGuard route - state: ', route, state);
    const tempToken: string = route.paramMap.get('tempToken');
    console.log('LoginByTokenGuard token: ', tempToken);
    // No tempToken is present. Redirect to default (Will be handled by DefaultRouteGuard).
    if (!tempToken) {
      return this._router.parseUrl(AngularPaths.DEFAULT);
    }
    const loginByTokenRequest: LoginByTokenRequest = { token: tempToken, consumer: this.currentConsumer };
    this._loading.showGlobalLoading();
    // TempToken is present and user dont have any session initialized.
    if (!this._session.checkTokenValid()) {
      return this._loginByToken(loginByTokenRequest).pipe(
        map(_ => false),
        finalize(() => this._loading.hideGlobalLoading())
      );
    }
    // TempToken is present and user already have a session initialized. Logout and logIn with new session.
    return this._session.removeSession().pipe(
      map(_ => false),
      finalize(() =>
        this._loginByToken(loginByTokenRequest)
          .pipe(finalize(() => this._loading.hideGlobalLoading()))
          .subscribe()
      )
    );
  }

  private _loginByToken(loginByTokenRequest: LoginByTokenRequest) {
    return this._session.initTokenSession(loginByTokenRequest);
  }
}
